import { Cubit } from "blac-next";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import {
  TaskKey,
  type TaskResponseKnown
} from "src/state/TaskManagementBloc/TaskManagementBloc";
import { taskManagementState } from "src/state/state";
import reportErrorSentry from "src/lib/reportErrorSentry";

export interface RateCoachingCallState {
  task?: TaskResponseKnown;
  hiddenFields: Record<string, string>;
  isLoading: boolean;
}

export default class RateCoachingCallCubit extends Cubit<RateCoachingCallState> {
  constructor() {
    super({
      task: undefined,
      hiddenFields: {},
      isLoading: false
    });
  }

  loadRateCoachingCallTaskForAppointment = async (
    appointmentId: string
  ): Promise<void> => {
    if (!appointmentId) {
      return;
    }

    this.emit({
      task: undefined,
      hiddenFields: {},
      isLoading: true
    });

    try {
      const tasks = await taskManagementState.loadProgramTasks(
        KnownProgram.CARE
      );

      const task = tasks
        ?.filter((t) => t.slug === TaskKey.COACHING_RATING)
        .find((t) => t.additionalData?.appointmentId === appointmentId);

      if (task) {
        const coachingName = task.additionalData?.coachingName as string;
        const coachingUserId = task.additionalData?.coachingUserId as string;
        const appointmentId = task.additionalData?.appointmentId as string;

        this.emit({
          task,
          hiddenFields: {
            taskId: task.id ?? "",
            coaching_name: coachingName,
            coaching_user_id: coachingUserId,
            appointmentId
          },
          isLoading: false
        });
      } else {
        this.emit({
          task: undefined,
          hiddenFields: {},
          isLoading: false
        });
      }
    } catch (error) {
      reportErrorSentry("Failed to load coaching call task", {
        error
      });

      this.emit({
        task: undefined,
        hiddenFields: {},
        isLoading: false
      });
    }
  };
}
